import React from 'react';
import * as U from "../../style/StyleComponentUtility";
import appLogo from "../../assets/images/ablack_app_logo.png";
import { useNavigate } from 'react-router-dom';

const NotFound: React.FC = () => {
    const navigate = useNavigate();
    return (
        <U.NotFoundContainer>
            <div className='main-box'>
                <div className='logo-box'>
                    <img src={appLogo} alt='' />
                </div>
                <div className='content-box'>
                    <div className='text-box'>
                        <p>404 Error</p>
                        <p>페이지를 찾을 수 없습니다.</p>
                        <p>
                            페이지가 존재하지 않거나, 사용할 수 없는 페이지입니다. <br />
                            입력한 주소가 정확한지 다시 한번 확인해 주세요.
                        </p>
                    </div>
                    <div className='button-box'>
                        <button onClick={() => navigate(-1)}>이전으로 돌아가기</button>
                        <button onClick={() => navigate('/main')}>메인으로 돌아가기</button>
                    </div>
                </div>
            </div>
        </U.NotFoundContainer>
    )
};

export default NotFound;